export default "__VITE_ASSET__CR8QQ0sz__"